import FinancialDeliveryMonitorPage from './pages/Financial/FinancialDeliveryMonitorPage';
import FinancialBillingConsultationPage from "./pages/Financial/FinancialBillingConsultationPage";
import React, { Suspense, useEffect, useState } from "react";
import { Switch, Redirect } from "react-router-dom";
import ErrorPage from "../errors/ErrorPage";
import AdminRoute from "./components/AdminRoute";
import {
  UserListing,
  UserForm,
  UserFormEdit,
  ClientForm,
  ClientFormEdit,
  LawsuitListing,
  LawsuitForm,
  LawsuitFormEdit,
  UserFormView,
  DocumentValidation,
  DocumentCadencePage,
} from "./pages";

import ParametrizacaoView from "./pages/Parametrizacao/ParametrizacaoView";
import LogsView from "./pages/Logs/LogsView";
import { Dashboard } from "./pages/Dashboard";
import { PublicationListing } from "./pages/Publication";
import { AssistantHandoffsPage, AssistantPage } from "./pages/Assistant";
import { isClientFinancialEnabled, isDocumentCadenceEnabled, isFinancialClientUser, isFinancialNativeReviewEnabled, isFinancialOfficeApprovalEnabled } from "../../utils/FeatureFlags";
import FinancialDashboardPage from "./pages/Financial/FinancialDashboardPage";
import FinancialNativeReviewPage from "./pages/Financial/FinancialNativeReviewPage";
import FinancialCollectionsPage from "./pages/Financial/FinancialCollectionsPage";
import FinancialVoicePage from "./pages/Financial/FinancialVoicePage";
import ClientFinancialPage from "./pages/Financial/ClientFinancialPage";
import { USER_ROLES } from "../../enum/UserRoles";
import { useSelector } from "react-redux";
import { GridStandards } from "./components/GridStandards/GridStandards";
import OperationsPage from "./pages/Operations/OperationsPage";

export default function AdminPage() {
  const [width, setWidth] = useState(window.innerWidth);
  const documentCadenceEnabled = isDocumentCadenceEnabled();
  const userRole = useSelector((state) => state.auth.user?.role);
  const userEmail = useSelector((state) => state.auth.user?.email);
  const financialUser = { role: userRole, email: userEmail };
  const initialRoute =
    userRole === USER_ROLES.CLIENT ? "/admin/dashboard" : "/admin/processo";

  const resizeEvent = () => {
    if (window.innerWidth !== width) {
      setWidth(window.innerWidth);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", resizeEvent);

    return () => window.removeEventListener("resize", resizeEvent);
  });

  return (
    <GridStandards>
      <Suspense>
        <Switch>
          <Redirect exact from="/admin" to={initialRoute} />
          {userRole === USER_ROLES.ADMIN && ["carlosxavier@advocaciaxavier.com", "fabiomag@gmail.com"].includes(userEmail?.toLowerCase()) && (
            <AdminRoute permissionLevel="ADMIN" exact path="/admin/saude-servicos" component={OperationsPage} />
          )}

          {userRole === USER_ROLES.ADMIN && (
            <AdminRoute permissionLevel="ADMIN" exact path="/admin/financeiro" component={FinancialDashboardPage} />
          )}
          {userRole === USER_ROLES.ADMIN && (
            <AdminRoute permissionLevel="ADMIN" exact path="/admin/financeiro/conferencia" component={FinancialBillingConsultationPage} />
          )}
          {userRole === USER_ROLES.ADMIN && (
            <AdminRoute permissionLevel="ADMIN" exact path="/admin/financeiro/revisao" component={() => isFinancialNativeReviewEnabled() && isFinancialOfficeApprovalEnabled() ? <FinancialNativeReviewPage /> : <Redirect to="/admin/financeiro/cobrancas" />} />
          )}
          {isClientFinancialEnabled() && isFinancialClientUser(financialUser) && (
            <AdminRoute permissionLevel="ANY" exact path="/admin/meu-financeiro" component={ClientFinancialPage} />
          )}
          {userRole === USER_ROLES.ADMIN && (
            <AdminRoute permissionLevel="ADMIN" exact path="/admin/financeiro/cobrancas" component={FinancialCollectionsPage} />
          )}
          {userRole === USER_ROLES.ADMIN && (
            <AdminRoute permissionLevel="ADMIN" exact path="/admin/financeiro/ligacoes" component={FinancialVoicePage} />
          )}

          {userRole === USER_ROLES.ADMIN && <AdminRoute permissionLevel="ADMIN" exact path="/admin/financeiro/envios" component={FinancialDeliveryMonitorPage} />}
          {/* USUÁRIOS */}
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/usuario"
            component={() => <UserListing width={width} />}
          />
          <AdminRoute
            permissionLevel="ANY"
            path="/admin/usuario/adicionar"
            component={UserForm}
          />
          <AdminRoute
            permissionLevel="ANY"
            path="/admin/usuario/:id/editar"
            component={UserFormEdit}
          />
          <AdminRoute
            permissionLevel="ANY"
            path="/admin/usuario/:id/visualizar"
            component={UserFormView}
          />
          {/* Clientes */}
          <AdminRoute
            permissionLevel="ANY"
            path="/admin/cliente/adicionar"
            component={ClientForm}
          />
          <AdminRoute
            permissionLevel="ANY"
            path="/admin/cliente/:id/editar"
            component={ClientFormEdit}
          />
          {/* Processos */}
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/processo"
            component={() => <LawsuitListing width={width} />}
          />
          <AdminRoute
            permissionLevel="ANY"
            path="/admin/processo/adicionar"
            component={LawsuitForm}
          />
          <AdminRoute
            permissionLevel="ANY"
            path="/admin/processo/:id/editar"
            component={LawsuitFormEdit}
          />
          {/* Documentos validação */}
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/acompanhamentoDocumentos"
            component={() => <DocumentValidation width={width} />}
          />
          {documentCadenceEnabled && (
            <AdminRoute
              permissionLevel="ANY"
              exact
              path="/admin/cadencia-documental"
              component={() => <DocumentCadencePage width={width} />}
            />
          )}
          {userRole === USER_ROLES.ADMIN && (
            <AdminRoute permissionLevel="ADMIN" exact path="/admin/parametrizacao/whatsapp" component={() => <Redirect to="/admin/parametrizacao?aba=whatsapp" />} />
          )}
          {/* PARAMETRIZAÇÃO */}
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/parametrizacao"
            component={() => <ParametrizacaoView width={width} />}
          />
          {/* LOGS */}
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/logs"
            component={() => <LogsView width={width} />}
          />
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/publicacoes"
            component={() => <PublicationListing width={width} />}
          />
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/assistente"
            component={() => <AssistantHandoffsPage width={width} />}
          />
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/assistente/handoffs"
            component={() => <AssistantHandoffsPage width={width} />}
          />
          {userRole === USER_ROLES.ADMIN && (
            <AdminRoute permissionLevel="ADMIN" exact path="/admin/parametrizacao/whatsapp" component={() => <Redirect to="/admin/parametrizacao?aba=whatsapp" />} />
          )}
          {/* PARAMETRIZAÇÃO */}
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/dashboard"
            component={() => <Dashboard width={width} />}
          />
          {/* ERROR */}
          <AdminRoute
            permissionLevel="ANY"
            path="/admin/*"
            component={ErrorPage}
          />
          <AdminRoute
            permissionLevel="ANY"
            exact
            path="/admin/404"
            component={ErrorPage}
          />
        </Switch>
        <AssistantPage embedded />
      </Suspense>
    </GridStandards>
  );
}
